import { render, staticRenderFns } from "./Submit.vue?vue&type=template&id=a359dd22&scoped=true&"
import script from "./Submit.vue?vue&type=script&lang=ts&"
export * from "./Submit.vue?vue&type=script&lang=ts&"
import style0 from "./Submit.vue?vue&type=style&index=0&id=a359dd22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a359dd22",
  null
  
)

export default component.exports